import { render, staticRenderFns } from "./PaymentPaytimz.vue?vue&type=template&id=6a83c132&scoped=true&"
import script from "./PaymentPaytimz.vue?vue&type=script&lang=js&"
export * from "./PaymentPaytimz.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPaytimz.vue?vue&type=style&index=0&id=6a83c132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83c132",
  null
  
)

export default component.exports